import {
    IQueryContext,
    IQueryContextDatasourceColumn,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    ICompiledSQLTokens,
    IDatasourceSQLMap,
    mergeSqlTokensArray,
} from 'src/app/utils/datasource-sql-map/datasource';
import { DatePickerSqlTokensCompiler } from 'src/app/utils/datasource-sql-map/date-picker-sql-tokens-compiler';
import { multipleSelectComponentCompileSQLTokens } from 'src/app/utils/datasource-sql-map/utils';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import { buildSplitGroupSQL, buildWhereSQL } from 'src/app/utils/query/sql';
import { sqlDateTrunc } from 'src/app/utils/sql';

export class DashboardSalesComparisonSqlMap {
    public static sqlMap: IDatasourceSQLMap = {
        dataset: 'bi_viz',
        tableId: 'dashboard_sales_comparison',
        columns: {
            ACTIVITY_DATE: {
                columnId: 'ACTIVITY_DATE',
                columnSQL: 'date',
                compileSQLTokens: (state) => {
                    return DatePickerSqlTokensCompiler.compileTokens(
                        'date',
                        state
                    );
                },
            },
            FIREBASE_APP_STORE: {
                columnId: 'FIREBASE_APP_STORE',
                columnSQL: 'store',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'store',
                        state
                    );
                },
            },
            FIREBASE_COUNTRY: {
                columnId: 'FIREBASE_COUNTRY',
                columnSQL: 'country',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'country',
                        state
                    );
                },
            },
        },
    };

    public static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        const dateTrunc = queryContextSettings.dateAggregation
            ? sqlDateTrunc('date', queryContextSettings.dateAggregation)
            : `date`;

        const sqlTokensArray: Partial<ICompiledSQLTokens>[] =
            supportedDatasourceColumns.map((dsCol) => {
                return this.sqlMap.columns[dsCol.id]!.compileSQLTokens!(
                    dsCol.state,
                    options
                );
            });
        // merge tokens into single deduplicated object of type ICompiledSQLTokens
        const sqlTokens: ICompiledSQLTokens =
            mergeSqlTokensArray(sqlTokensArray);

        const splitSelect: string = buildSplitGroupSQL(sqlTokens.split_group);
        const splitGroupBy = splitSelect ? 'split_group, ' : '';
        const where: string = buildWhereSQL([
            ...sqlTokens.where,
            ...(customCompiledSqlTokens?.where ?? []),
        ]);

        return {
            dateTrunc,
            splitSelect,
            splitGroupBy,
            where,
        };
    }
}
